module.exports = __webpack_public_path__ + "img/parabens.9b0e34c1.jpg";